import { render, staticRenderFns } from "./PostProducerControls.vue?vue&type=template&id=2bd59ca3&scoped=true&"
import script from "./PostProducerControls.vue?vue&type=script&lang=js&"
export * from "./PostProducerControls.vue?vue&type=script&lang=js&"
import style0 from "./PostProducerControls.vue?vue&type=style&index=0&id=2bd59ca3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd59ca3",
  null
  
)

export default component.exports